<template>
  <section
    v-if="dataLoaded"
    :key="reloaderState"
    class="content"
  >
    <change-state-modal
      :is-form-valid="isFormValid"
      :change-state-event="events.changeState"
      :task-id="this.$route.params.appraisalTaskId"
      :task-state="task.state ? task.state.name : ''"
      :service="service"
      :show="changeStateVisible"
      :simple-transition="simpleTransition"
      :workflow-name="`appraisal`"
      @close="changeStateVisible = false"
    />
    <clone-task
      :service="service"
      :task-id="this.$route.params.id"
      :appraisal-task-id="this.$route.params.appraisalTaskId"
      :task-type="taskType"
      :show="cloneTaskModalVisible"
      :workflow-name="workflowName"
      @close="cloneTaskModalVisible = false"
    />
    <change-assignee-modal
      :assignee-uuid="task.assignee ? task.assignee.uuid : ''"
      :task-id="task.id"
      :service="service"
      :show="changeAssigneeModalVisible"
      @close="changeAssigneeModalVisible = false"
      :task="task"
    />
    <!-- <generate-document
        :taskId="this.$route.params.id"
        :taskState="task.state ? task.state.name : ''"
        :task="task"
        :taskData="taskData"
        :taskType="taskType"
        :availableDocuments="availableDocuments"
        :show="generateDocumentVisible"
        @close="generateDocumentVisible = false"
      >
      </generate-document> -->
    <comment-modal
      slot="comments"
      :show="openCommentModal"
      :avatar="avatar"
      :service="service"
      :task-type="taskType"
      @close="openCommentModal = false"
    />
    <invoice-modal
      v-if="openInvoiceModal"
      :show="openInvoiceModal"
      :service="service"
      :task-number="taskNumber"
      @success="handleAddInvoiceModal"
      @close="openInvoiceModal = false"
      :task-type="'appraisal'"
    />
    <ConfirmDeleteInvoiceModal
      v-if="confirmDeleteInvoiceVisible"
      :show="confirmDeleteInvoiceVisible"
      :totalItems="this.selectedInvoices.length"
      @close="() => confirmDeleteInvoiceVisible = false"
      @confirm="() => handleDeleteInvoice()"
    >
    </ConfirmDeleteInvoiceModal>
    <div class="row">
      <div class="details-screen">
        <task-header
          v-if="task"
          :service="service"
          :data-to-show="taskHeaderData"
          class="floating-task-header"
          :task="task"
          :task-data="taskData"
          :client="client || ''"
          @task-header-shadow="m$handleTaskHeaderShadow"
          @task-header-collapsed="m$handleTaskHeaderCollapsed"
        />
        <tabs
          :tabs-data="tabsData"
          class="task-form"
          @clickedTab="reactToTabChange"
          :topDistance="m$tabsTopDistance"
        >
          <form-schema
            slot="formularz"
            ref="formSchema"
            :service="service"
            :task="task"
            :task-data="taskData"
            :category-group="categoryGroup"
            @form-validity="setFormValidity"
          />
          <div slot="fv">
            <invoice
              :task="task"
              :service="service"
              :task-id="Number(this.$route.params.id)"
              :client="client || ''"
              :task-type="'appraisal'"
              :reloadInvoices.sync="reloadInvoices"
              @onUpdateSelectedInvoice="updateSelectedInvoice"
            />
          </div>
          <attachments
            v-if="activeTab === 'attachments'"
            slot="attachments"
            ref="attachments"
            :active-tab="activeTab"
            :path="path"
            :filePaths="[taskFilePath]"
            :filePath="taskFilePath"
            :service="service"
            :subtasks="task.subtasks"
            :task-id="task.id"
            :task="task"
            :task-number="taskNumber"
            :task-type="taskType"
            :task-state="task.state"
            @attachments-count-changed="loadNumberOfAttachments"
          />
          <div slot="comments">
            <comments
              :avatar="avatar"
              :service="service"
              :task-type="taskType"
              :task="task"
            />
          </div>
          <div slot="history">
            <history
              v-if="activeTab === 'history'"
              :task-uuid="task.uuid"
              :service="service"
            />
          </div>
          <div slot="fokusIframe">
            <fokus-iframe :task="task" :service="service"></fokus-iframe>
          </div>
          <div slot="fokusIframeOld">
            <fokus-iframe :task="task" :service="service" :type="TYPE_OLD_FOKUS"></fokus-iframe>
          </div>
          <div slot="fokusIframeNew">
            <fokus-iframe :task="task" :service="service" :type="TYPE_NEW_FOKUS"></fokus-iframe>
          </div>
        </tabs>
      </div>
    </div>
  </section>
</template>

<script>
import Page from '../../../../share/content/Page'
import FormSchema from '../form/Schema'
import api from '../../../../../api'
import Tabs from '../../../../share/tabs/Tabs'
import ChangeStateModal from '../../MainTask/ChangeStateModal/ChangeState'
import Attachments from '../../../share/attachment/Attachments'
import Comments from '../../../share/comment/Comments'
// import GenerateDocument from '../../../share/generateDocument/modal/GenerateDocument'
import CommentModal from '../../../share/comment/modal/CommentModal'
import DynamicBreadcrumb from '../../../share/mixins/DynamicBreadcrumb'
import History from '../../../../share/history/History'
import Invoice from '../../../share/invoice/Invoice'
import InvoiceModal from '../../../share/invoice/modal/InvoiceModal'
import TaskHeader from '../../../share/TaskHeader/TaskHeader'
import TaskThirdMenu from '../../../share/mixins/TaskThirdMenu/taskThirdMenu.js'
import CloneTask from '../../MainTask/cloneTaskModal/CloneTask'
import ChangeAssigneeModal from '../../MainTask/changeAssigneeModal/ChangeAssignee'
import FokusIframe from '../../../share/fokus-iframe/FokusIframe'
import moment from 'moment'
import {TYPE_NEW, TYPE_OLD} from '@/components/bundles/share/fokus-iframe/fokusIframeTypes.js'
import tabsDistanceMixin from '@/components/share/mixins/tabsDistanceMixin.js'
import ConfirmDeleteInvoiceModal from '@/components/bundles/share/modal/confirmDeleteInvoice/ConfirmDeleteInvoiceModal.vue'

export default {
  name: 'TaskDetails',
  components: {
    CloneTask,
    ChangeAssigneeModal,
    Invoice,
    InvoiceModal,
    CommentModal,
    FormSchema,
    Tabs,
    ChangeStateModal,
    Comments,
    Attachments,
    // GenerateDocument,
    History,
    TaskHeader,
    FokusIframe,
    ConfirmDeleteInvoiceModal
  },
  mixins: [
    DynamicBreadcrumb,
    Page,
    TaskThirdMenu,
    tabsDistanceMixin
  ],
  data () {
    return {
      categoryGroup: 'appraisal',
      events: null,
      // sprawdza formularz pod kątem wymagalności pól, (na przyszłość, gdy będzie potrzeba walidacji przy przejsciu na kolejny stan)
      isFormValid: false,
      headerTitle: { title: 'Zlecenie' },
      taskNumber: '',
      path: '',
      filesCount: 0,
      task: {},
      taskFilePath: '',
      taskData: {},
      reloaderState: 0,
      // availableDocuments: [],
      // generateDocumentVisible: false,
      dataLoaded: false,
      tabsData: [],
      changeStateVisible: false,
      changeAssigneeModalVisible: false,
      cloneTaskModalVisible: false,
      openCommentModal: false,
      commentsListOnly: false,
      openInvoiceModal: false,
      service: this.$route.meta.acl.service,
      simpleTransition: false,
      taskType: this.$route.meta.taskType,
      workflowName: this.$route.meta.workflowName,
      client: this.$route.meta.client,
      goFurtherModal: false,
      confirmDeleteInvoiceVisible: false,
      selectedInvoices: [],
      reloadInvoices: false,
      avatar: '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'
    }
  },
  computed: {
    TYPE_NEW_FOKUS () {
      return TYPE_NEW
    },
    TYPE_OLD_FOKUS () {
      return TYPE_OLD
    },
    activeTab () {
      return this.tabsData.find(tab => tab[2] === true)[0]
    },
    tabThirdMenu () {
      return {
        fv: [
          {
            event: { name: `${this.service}:appraisal:addInvoice` },
            icon: 'plus',
            label: 'Dodaj fakturę',
            acl: { service: this.service, action: 'put_invoice' }
          },
          {
            event: { name: `${this.service}:appraisal:deleteInvoice` },
            icon: 'minus',
            label: 'Usuń fakturę',
            acl: { service: this.service, action: 'delete_invoices' }
          },
        ],
        formularz: [
          {
            event: { name: `${this.service}:appraisal:cloneTask` },
            icon: 'copy',
            label: 'Kopiuj zlecenie',
            acl: { service: this.service, action: this.$isWithClients(this.service) ? `post_task__copy__${this.$route.meta.client}` : 'post_appraisal_task_copy' }
          }
        ],
        fokusIframeNew: this.fokusIframeNewButtons,
        fokusIframeOld: this.fokusIframeOldButtons
      }
    },
    workflowNameUrl () {
      return this.workflowName.split('_').join('-')
    },
    taskHeaderData () {
      // TODO Get task header data from backend
      if (this.task) {
        return [
          [
            [this.task.state ? this.task.state.label : 'b.d.', 'Status', `${this.task.id}-header-state`],
            [this.task.author ? (this.task.author.fullname ? this.task.author.fullname : (this.task.author.label ? this.task.author.label : 'b.d.')) : 'b.d.', 'Autor', `${this.task.id}-header-author`],
            [this.task.assignee ? (this.task.assignee.fullname ? this.task.assignee.fullname : (this.task.assignee.label ? this.task.assignee.label : 'b.d.')) : 'b.d.', 'Opiekun', `${this.task.id}-header-assignee`]
          ],
          [
            [this.task.additionalData && this.task.additionalData.appraisalOrderType || 'b.d', 'Zlecenie', `${this.task.id}-header-appraisalOrderType`],
            [this.taskData.initialDate ? this.formatDate(this.taskData.initialDate, 'YYYY-MM-DD') : 'b.d', 'Zlecone', `${this.task.id}-header-initialDate`],
            [this.taskData.initialDate ? this.expectedAccomplishmentDate : 'b.d.', 'Oczekiwane', `${this.task.id}-header-expectedAccomplishmentDate`],
            [this.taskData.accomplishAt || 'b.d.', 'Wykonane', `${this.task.id}-header-accomplishAt`]
          ]
        ]
      } else {
        return []
      }
    },
    expectedAccomplishmentDate () {
      if (this.taskData && this.taskData.initialDate) {
        return moment(this.taskData.initialDate).add(2, 'days').format('YYYY-MM-DD')
      } else {
        return null
      }
    }
  },
  watch: {
    task: function (newTask) {
      this.taskNumber = newTask.number
      this.path = newTask.createdAt.substr(0, 7).replace('-', '')
    }
  },
  created () {
    this.getInitEvents()
  },
  mounted () {
    this.$events.on(this.events.changeState, this.changeState)
    this.$events.on(this.events.addAttachment, this.addAttachment)
    this.$events.on(this.events.addComment, this.addComment)
    this.$events.on(this.events.generateDocument, this.generateDocument)
    this.$events.on(this.events.addInvoice, this.addInvoice)
    this.$events.on(this.events.deleteInvoice, this.deleteInvoice)
    this.$events.on(this.events.changeAssignee, this.changeAssignee)
    this.$events.on(this.events.cloneTask, this.cloneTask)
    this.$events.on(this.events.simpleTransition, this.doSimpleTransition)
    this.$events.on(this.events.sendFocusSms, this.sendFocusSms)
    this.$events.on(this.events.sendFocusSmsNew, this.sendFocusSmsNew)
    this.$events.on(this.events.refetchTask, this.refetchTaskData);

    this.loadTaskData()
  },
  methods: {
    handleAddInvoiceModal () {
      this.openInvoiceModal = false
      this.$events.emit('invoices:updated')

      this.selectedInvoices = []
    },
    formatDate (date, format) {
      return moment(date).format(format)
    },
    getInitEvents () {
      this.events = {
        changeState: `${this.service}:appraisal:changeState`,
        cloneTask: `${this.service}:appraisal:cloneTask`,
        changeAssignee: `${this.service}:appraisal:changeAssignee`,
        addAttachment: `${this.service}:appraisal:addAttachments`,
        addComment: `${this.service}:appraisal:addComment`,
        generateDocument: `${this.service}:appraisal:generateDocument`,
        addInvoice: `${this.service}:appraisal:addInvoice`,
        deleteInvoice: `${this.service}:appraisal:deleteInvoice`,
        simpleTransition: `${this.service}:main:simpleTransition`,
        sendFocusSms: `${this.service}:appraisal:sendFocusSms`,
        sendFocusSmsNew: `${this.service}:appraisal:sendFocusSmsNew`,
        refetchTask: `${this.service}:appraisal:refetchTask`,
      }
    },
    getTabs () {
      let tabs = [
        [
          'formularz',
          'Formularz',
          true,
          [this.$isWithClients(this.service) ? `${this.service}.get_task__appraisal__${this.$route.meta.client}` : `${this.service}.get_appraisal_task`]
        ],
        [
          'fv',
          'FV',
          false,
          [`${this.service}.get_invoice`]
        ],
        [
          'attachments',
          `Załączniki ${this.filesCount !== 0 ? '(' + this.filesCount + ')' : ''}`,
          false,
          ['storage.get_files']
        ],
        [
          'comments',
          'Komunikacja',
          false,
          [
            this.$isWithClients(this.service) ? `${this.service}.get_comments__appraisal_internal` : `${this.service}.get_comments_appraisal_internal`,
            this.$isWithClients(this.service) ? `${this.service}.get_comments__appraisal_private` : `${this.service}.get_comments_appraisal_private`,
            this.$isWithClients(this.service) ? `${this.service}.get_comments__appraisal_public` : `${this.service}.get_comments_appraisal_public`
          ]
        ],
        [
          'history',
          'Historia',
          false,
          ['history.get_subject_changes']
        ]//,
        // [
        //   'fokusIframe',
        //   this.$t('pages.taskDetails.tabs.fokus'),
        //   false,
        //   [`${['intgen','intbls'].includes(this.service) ? '' : this.service}.frontend_acl_${this.workflowNameUrl}_focus_tab`]
        //]
      ]
      if (['intgen','intbls','intvhs'].includes(this.service)) {
        tabs = tabs.concat(
          [
            [
              'fokusIframeNew',
              `${this.$t('pages.taskDetails.tabs.fokus')}`,
              false,
              [this.service+`.get_fokus_operator_url_new`]
            ],
            [
              'fokusIframeOld',
              `${this.$t('pages.taskDetails.tabs.fokus')} (starsza wersja)`,
              false,
              [this.service+`.get_fokus_operator_url`]
            ]
          ]
        )
      }
      this.tabsData = tabs
    },
    setFormValidity (validity) {
      this.isFormValid = validity
    },
    changeState () {
      if (this.$refs.formSchema.checkRequiredFields()) {
        if (this.simpleTransition === false) {
          this.changeStateVisible = true
        }
      } else {
        this.$refs.formSchema.toggleRequiredFieldsErrorStyle()
        this.$notify({
          type: 'error',
          text: this.$t('modals.changeState.validationError', {fields: this.$refs.formSchema.showRequiredFields()})
        })
      }
    },
    // generateDocument () {
    //   this.generateDocumentVisible = true
    //   this.getAvailableDocuments()
    // },
    loadTaskData () {
      api.request(this.service, 'get', this.$isWithClients(this.service) ? `/tasks/${this.$route.params.appraisalTaskId}?appraisal=true&client=${this.$route.meta.client}` : `/tasks/${this.$route.params.id}/appraisal/${this.$route.params.appraisalTaskId}`)
        .then((response) => {
          this.toggleLoading()

          this.task = response.data.task
          delete response.data.task
          this.taskData = response.data
          this.taskNumber = this.task.number
          this.path = moment(this.task.createdAt).format('YYYYMM')
          this.taskFilePath = this.path + '/' + this.taskNumber.split('/').join('_')

        this.getTabs()

          document.title = this.task.number ? `${this.task.number}` : `${this.task.id}`

          // dynamic breadcrumb labels
          if (this.$isWithClients(this.service)) {
            this.addDynamicBreadcrumbLabel(`${this.service}_${this.$route.meta.client}_${this.$route.meta.workflowName}_task_details`, this.task.number.split('-')[0])
          } else {
            this.addDynamicBreadcrumbLabel(`${this.service}_${this.$route.meta.workflowName}_task_details`, this.task.number.split('-')[0])
          }
          this.addDynamicBreadcrumbLabel(this.$route.name, this.task.number)

          this.reactToTabChange('formularz')
          this.dataLoaded = true

          if (this.task.state.final) {
            this.$events.$emit('dashboard:submenu:taskInFinalState', true)
          }
        this.loadNumberOfAttachments()
      })
        .catch((error) => {
          if (error.response && error.response.data && error.response.data.error.message.includes('access_denied')) {
            this.$router.push({ name: 'dashboard' })
            this.toggleLoading()
            this.$notify({
              type: 'error',
              title: 'Przekierowano',
              text: 'Brak dostępu do zlecenia'
            })
          } else {
            this.toggleLoading()
            this.$notify({
              type: 'error',
              title: 'Wystąpił błąd',
              text: 'Nie można załadować danych'
            })
          }
        })
    },
    refetchTaskData(fieldData) {
      api.request(this.service, 'get', this.$isWithClients(this.service) ? `/tasks/${this.$route.params.appraisalTaskId}?appraisal=true&client=${this.$route.meta.client}` : `/tasks/${this.$route.params.id}/appraisal/${this.$route.params.appraisalTaskId}`)
        .then((response) => {
          this.toggleLoading()
          this.task = response.data.task
          delete response.data.task
          this.taskData = Object.assign({}, response.data)
          if (fieldData) {
            this.$events.$emit(
              `${this.service}:${this.categoryGroup}:refetchTaskComplete`,
              { taskData: this.taskData, field: fieldData }
            );
          }
          this.dataLoaded = true
        })
        .catch((error) => {
          if (error.response && error.response.data && error.response.data.error.message.includes('access_denied')) {
            this.$router.push({ name: 'dashboard' })
            this.toggleLoading()
            this.$notify({
              type: 'error',
              title: 'Przekierowano',
              text: 'Brak dostępu do zlecenia'
            })
          } else {
            this.toggleLoading()
            this.$notify({
              type: 'error',
              title: 'Wystąpił błąd',
              text: 'Nie można załadować danych'
            })
          }
        })
    },
    async loadNumberOfAttachments() {
      try {
        let { data } = await api.request('storage', 'get', `/download/${this.service}?format=names&filePaths=${this.taskFilePath}`)
        this.filesCount = data.length
        this.tabsData = this.tabsData.map(([tag, title, ...params]) => tag === 'attachments' ? [tag, `Załączniki ${this.filesCount !== 0 ? '(' + this.filesCount + ')' : ''}`, ...params] : [tag, title, ...params])
      } catch (e) {
        console.error(e)
      }
    },
    // getAvailableDocuments () {
    //   api.request(this.service, 'get', `/documents-templates`)
    //     .then((response) => {
    //       this.toggleLoading()

    //       this.availableDocuments = response.data
    //       delete response.data
    //     })
    //     .catch(() => {
    //       this.toggleLoading()
    //       this.$notify({
    //         type: 'error',
    //         title: 'Wystąpił błąd',
    //         text: 'Nie można załadować danych'
    //       })
    //     })
    // },
    addAttachment () {
      this.reactToTabChange('attachments')
    },
    addComment () {
      this.openCommentModal = true
    },
    addInvoice () {
      this.openInvoiceModal = true
    },
    deleteInvoice() {
      this.confirmDeleteInvoiceVisible = true;
    },
    changeAssignee () {
      if (!this.task.assignee) {
        this.$notify({
          type: 'info',
          text: 'Zmiana odpowiedzialnego w tym statusie nie jest możliwa'
        })
        return
      }
      this.changeAssigneeModalVisible = true
    },
    doSimpleTransition () {
      this.simpleTransition = true
    },
    cloneTask () {
      this.cloneTaskModalVisible = true
    },
    reactToTabChange (tabName) {
      this.tabsData = this.tabsData.map(tab => tab[0] === tabName ? (tab.map((tabProp, index) => index === 2 ? (tabProp = true) : tabProp)) : (tab.map((tabProp, index) => index === 2 ? (tabProp = false) : tabProp)))
      /* if (tabName === 'information') {
        this.$events.$emit('bundles:attachments:reloadData')
      } */

      let menu = []
      if (this.tabThirdMenu.hasOwnProperty(tabName)) {
        menu = this.tabThirdMenu[tabName]
      }
      this.$events.$emit('dashboard:menu:taskTab', menu)
    },
    sendFocusSms () {
      api.request(this.service, 'post', `/notifications/${this.task.uuid}/focus-sms`, {})
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Sukces',
            text: 'Ponowny sms do fokus został wysłany'
          })
        })
        .catch(() => {
          this.$notify({
            type: 'error',
            title: 'Wystąpił błąd',
            text: `Błąd przy wysyłaniu sms'a do fokus`
          })
        })
    },
    sendFocusSmsNew () {
      api.request(this.service, 'post', `/notifications/${this.task.uuid}/focus-sms-new`, {})
        .then(() => {
          this.$notify({
            type: 'success',
            title: this.$t('success.default'),
            text: this.$t('pages.taskDetails.fokusSmsSentSuccesfully')
          })
        }).catch(() => {
          this.$notify({
            type: 'error',
            title: this.$t('error.default'),
            text: this.$t('pages.taskDetails.fokusSmsError')
          })
        })
    },
    updateSelectedInvoice(id) {
      if (this.selectedInvoices.includes(id)) {
        this.selectedInvoices = this.selectedInvoices.filter(invoiceId => invoiceId !== id)
      } else {
        this.selectedInvoices = this.selectedInvoices.concat(id)
      }
    },
    handleDeleteInvoice() {
      let prefixUrl = this.$isWithClients(this.service) ? '' : '/tasks';
      let url = `${prefixUrl}/invoices?items[]=${this.selectedInvoices.join('&items[]=')}`

      api.request(this.service, 'delete', url)
        .then(() => {
          this.confirmDeleteInvoiceVisible = false
          this.reloadInvoices = true

          this.selectedInvoices = []
          })
        .catch(() => {
          this.toggleLoading()
          this.$notify({
            type: 'error',
            title: 'Wystąpił błąd',
            text: 'Nie można usunąć faktur(y)'
          })
        })
    }
  }
}
</script>
